import {JsonObject, JsonProperty} from "json2typescript";

import {DataType, STRING_TYPE} from "../../stores/database-template/database-form-base";
import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("TemplateItemOptions")
export class TemplateItemOptions {
    @JsonProperty()
    public link_url: string | null = null;

    @JsonProperty()
    public alt_text: string | null = null;

    @JsonProperty()
    public source_url: string | null = null;

    @JsonProperty()
    public source_text: string | null = null;

    constructor(init?: Partial<TemplateItemOptions>) {
        Object.assign(this, init);
    }
}

@JsonObject("TemplateItem")
export class TemplateItem {
    @JsonProperty()
    public columnId: string = "";

    @JsonProperty()
    public slug: string = "";

    @JsonProperty()
    public type: DataType = STRING_TYPE;

    @JsonProperty()
    public value: string = "";

    @JsonProperty("options", TemplateItemOptions)
    public options: TemplateItemOptions = JsonPropertyEmpty;

    @JsonProperty()
    public deleted: boolean = false;

    constructor(init?: Partial<TemplateItem>) {
        Object.assign(this, init);
    }
}

@JsonObject("TemplateItemsWithItemIdOutput")
export class TemplateItemsWithItemIdOutput {
    @JsonProperty()
    public itemId: string = "";
    @JsonProperty()
    public itemLabel: string = "";
    @JsonProperty("items", [TemplateItem])
    public items: TemplateItem[] = JsonPropertyEmpty;

    constructor(init?: Partial<TemplateItemsWithItemIdOutput>) {
        Object.assign(this, init);
    }
}
